$(document).on("click", ".b-footer .b-footer__list-element--bold [data-toggle=\"collapse\"]", function () {
  $(this).fadeOut();
});
